export const PILLAR_PRESETS = [
  { color_key: "people_and_culture", name: "People & Culture", hex: "#002FA7", bg: "#EFF4FF" },
  { color_key: "systems_and_governance", name: "Systems & Governance", hex: "#C8102E", bg: "#FFF1F2" },
  { color_key: "operations_and_delivery", name: "Operations & Delivery", hex: "#B45309", bg: "#FFFBEB" },
  { color_key: "stakeholder_alignment", name: "Stakeholder Alignment", hex: "#1B4D3E", bg: "#ECFDF5" },
];

const CUSTOM_HEX = ["#0F766E", "#7C2D12", "#3730A3", "#52525B", "#0E7490"];

export function customColor(index) {
  return CUSTOM_HEX[index % CUSTOM_HEX.length];
}

export function pillarStyle(pillar) {
  const preset = PILLAR_PRESETS.find((p) => p.color_key === pillar?.color_key);
  if (preset) return { hex: preset.hex, bg: preset.bg };
  const hex = pillar?.hex || "#030712";
  return { hex, bg: `${hex}14` };
}

export const HORIZON_TEMPLATES = {
  thirty_sixty_ninety: [
    { key: "h_30", label: "Days 1\u201330", posture: "Absorb & Align", sub: "Chronic Unease / Deep Diagnostics" },
    { key: "h_60", label: "Days 31\u201360", posture: "Diagnose & Design", sub: "Systemic Evaluation" },
    { key: "h_90", label: "Days 61\u201390", posture: "Deploy & Deliver", sub: "High-Performance Execution" },
  ],
  tactical_sprint: [
    { key: "w_12", label: "Weeks 1\u20132", posture: "Absorb & Align", sub: "Rapid Diagnostics" },
    { key: "w_34", label: "Weeks 3\u20134", posture: "Diagnose & Design", sub: "Systemic Evaluation" },
    { key: "w_56", label: "Weeks 5\u20136", posture: "Deploy & Deliver", sub: "High-Velocity Execution" },
  ],
  macro_vision: [
    { key: "q_1", label: "Quarter 1", posture: "Absorb & Align", sub: "Diagnostics & Foundations" },
    { key: "q_2", label: "Quarter 2", posture: "Diagnose & Design", sub: "Systemic Evaluation" },
    { key: "q_3", label: "Quarter 3", posture: "Deploy & Deliver", sub: "Execution & Embedding" },
    { key: "q_4", label: "Quarter 4", posture: "Scale & Sustain", sub: "Optimisation & Scale" },
  ],
};

export const PLAN_TYPES = [
  { value: "tactical_sprint", name: "Tactical Sprint", span: "Weeks 1\u20132 · 3\u20134 · 5\u20136", tag: "6 weeks", accent: "#B45309",
    blurb: "Sharp, fast execution for a focused project." },
  { value: "thirty_sixty_ninety", name: "30-60-90 Plan", span: "Days 1\u201330 · 31\u201360 · 61\u201390", tag: "90 days", accent: "#002FA7",
    blurb: "The classic onboarding and turnaround cadence." },
  { value: "macro_vision", name: "Macro Vision", span: "Quarter 1 · 2 · 3 · 4", tag: "Annual", accent: "#1B4D3E",
    blurb: "A four-quarter strategic arc for the long game." },
];

export function getHorizons(planType) {
  return HORIZON_TEMPLATES[planType] || HORIZON_TEMPLATES.thirty_sixty_ninety;
}

export const HORIZONS = HORIZON_TEMPLATES.thirty_sixty_ninety;

export const TRIGGERS = [
  { value: "executive_onboarding", label: "Executive Onboarding" },
  { value: "functional_realignment", label: "Functional Realignment" },
  { value: "project_recovery", label: "Project Recovery" },
  { value: "merger_integration", label: "Merger Integration" },
];

export const MATURITY = [
  { value: "nascent", label: "Nascent" },
  { value: "developing", label: "Developing" },
  { value: "established", label: "Established" },
  { value: "optimized", label: "Optimized" },
];

export const STATUSES = [
  { value: "todo", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "complete", label: "Complete" },
];

export function normalizeSteps(steps) {
  if (!Array.isArray(steps)) return [];
  return steps.map((s) =>
    typeof s === "string" ? { text: s, done: false } : { text: s?.text ?? "", done: !!s?.done }
  );
}

// Action status is DERIVED from sub-task completion (no manual status anymore):
// no steps or none checked = not started · some checked = in progress · all checked = complete.
export const STATUS_META = {
  not_started: { label: "Not Started", hex: "#EA580C", bg: "#FFF7ED" }, // orange
  in_progress: { label: "In Progress", hex: "#2563EB", bg: "#EFF6FF" }, // blue
  complete: { label: "Complete", hex: "#16A34A", bg: "#F0FDF4" },       // green
};

export function deriveStatus(steps) {
  const s = normalizeSteps(steps);
  if (s.length === 0) return "not_started";
  const done = s.filter((x) => x.done).length;
  if (done === 0) return "not_started";
  if (done === s.length) return "complete";
  return "in_progress";
}

export function getSessionId() {
  let sid = localStorage.getItem("planiq_session");
  if (!sid) {
    sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("planiq_session", sid);
  }
  return sid;
}
